import { RequestService } from 'Utils/Api';
import { logger } from 'Utils/Logger';
import { getDefaultConfig } from 'Utils/Store';

export const submitDocUpload = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('submit documents for verification', payload);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/docUpload`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('submit documents for verification', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('submit documents for verification', error.response.data, error);
      return Promise.reject(error.response.data.errorMessage);
    }
    logger.apiError('submit documents for verification', null, error);
    return Promise.reject(error);
  }
};

export const requestDocUpload = async (files, filesToUpload) => {
  try {
    for (let i = 0; i < files.length; i += 1) {
      await RequestService.send({
        url: files[i].uploadUrl,
        method: 'PUT',
        data: filesToUpload[i],
      });
    }
  } catch (error) {
    if (error?.response?.data) {
      return Promise.reject(error.response.data.errorMessage);
    }
    return Promise.reject(error);
  }
};

export const completeDocUpload = async (payload) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('complete documents for verification', payload);
  try {
    const { data } = await RequestService.send({
      url: `${foxApi}/memberverify/verification/step/completeDocUpload`,
      method: 'POST',
      data: payload,
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('complete documents for verification', data);
    return data;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('complete documents for verification', error.response.data, error);
      return Promise.reject(error.response.data.errorMessage);
    }
    logger.apiError('complete documents for verification', null, error);
    return Promise.reject(error);
  }
};
